import { ArrowLeftIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import classNames from 'classnames';
import { Button } from '@repo/ui';

import { useLayoutContext } from '@shared/contexts/LayoutContext';

interface Props {
  testId: TestId;
  onGoBack: () => void;
  headerText?: string;
}

const RIGHT_PADDING_THAT_EQUALS_SIZE_OF_BUTTON_FOR_ALIGNEMENT = 'pr-10.5';

export default function PageHeader({ testId, onGoBack, headerText }: Props) {
  const { headerTheme } = useLayoutContext();

  return (
    <div
      className={classNames(
        'z-sticky-header sticky top-0 flex p-4',
        RIGHT_PADDING_THAT_EQUALS_SIZE_OF_BUTTON_FOR_ALIGNEMENT,
        {
          'bg-soft-orange': headerTheme === 'soft-orange',
          'border-b-stroke-base border-b bg-white': headerTheme === 'white',
          'bg-brand-strong': headerTheme === 'brand',
        }
      )}
    >
      <Button
        onClick={onGoBack}
        variant="solid"
        color="ghost"
        iconOnly
        leftIcon={ArrowLeftIcon}
        aria-label={tr('actions.close')}
        testId={testId}
        className={classNames('[&>svg]:size-6', {
          'text-heading': headerTheme === 'soft-orange' || headerTheme === 'white',
          'text-white': headerTheme === 'brand',
        })}
      />
      {headerText && (
        <div
          className={classNames('flex w-full items-center justify-center text-center leading-6 font-semibold', {
            'text-heading': headerTheme === 'soft-orange' || headerTheme === 'white',
            'text-white': headerTheme === 'brand',
          })}
        >
          {headerText}
        </div>
      )}
    </div>
  );
}
